import api from 'api/api'

import { toast } from "react-toastify"
import { API_URL } from 'constants/index'

export const GET_ESTABLISHMENT = "[ESTABLISHMENT] GET ESTABLISHMENT"

export const CRUD_ESTABLISHMENT = "[ESTABLISHMENT] CRUD ESTABLISHMENT"

export const GET_BRANCHES = "[BRANCHES] GET BRANCHES"

export const CRUD_BRANCH = "[BRANCHES] CRUD BRANCH"

export const GET_OPTIONS_BY_BRANCH = "[OPTIONS] GET OPTIONS BY BRANCH"

export const CRUD_BRANCH_OPTION = "[OPTIONS] CRUD OPTIONS BRANCH"

export const GET_BANK_ACCOUNTS = "[BANK ACCOUNTS] GET BANK ACCOUNTS"

export const CRUD_BANK_ACCOUNT = "[BANK ACCOUNTS] CRUD BANK ACCOUNT"

export function getEstablishment() {
  const request = api.get(`/establecimiento/datos`)
  return (dispatch) => {
    dispatch({ type: GET_ESTABLISHMENT, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: null } })
      toast.error("No se pudo obtener los datos del establecimiento")
      console.log(error)
    })
  }
}

export function saveEstablishment(form) {
  const request = api.post(`/establecimiento/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function getBranches() {
  const request = api.get(`/sucursal/registros`)
  return (dispatch) => {
    dispatch({ type: GET_BRANCHES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BRANCHES, payload: { loading: false, data: response.data.detalles } })
    })
  }
}

export function saveBranch(form) {
  const request = api.post(`/sucursal/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function deleteBranch(form) {
  const request = api.post(`/sucursal/eliminar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function getOptionsByBranch(branchId = 0) {
  const request = api.get(`/opciones/obtener-por-sucursal/${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: false, data: null } })
      toast.error("No se pudo obtener las opciones de la sucursal")
      console.log(error)
    })
  }
}

export function saveOptionIgvType(form) {
  const request = api.post(`/opciones/guardar-tipo-igv`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveOptionLogo(form) {
  const request = api.post(`/opciones/guardar-logo`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function getBankAccounts() {
  const request = api.get(`/gcuentasbancarias`)
  return (dispatch) => {
    dispatch({ type: GET_BANK_ACCOUNTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BANK_ACCOUNTS, payload: { loading: false, data: response.data.detalles } })
      return
    })
  }
}

export function saveBankAccount(form) {
  const request = api.post(`/rcuentabancaria`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function deleteBankAccount(form) {
  const request = api.post(`/ecuentabancaria`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BANK_ACCOUNT, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}